import {useMemo} from 'react'

const shouldInclude = (item, expandedGroups) => item.type !== 'item' || !item.group || expandedGroups.has(item.group)

export const useFilteredItems = (items, expandedGroups) => {
	return useMemo(() => items.filter(item => shouldInclude(item, expandedGroups)), [items, expandedGroups])
}
